import React from "react";
import { Button } from "@/design-system/components/react";
import { FaExclamationTriangle, FaRedo } from "../../utils/icons";

/**
 * Error state (LU-A10 + LU-A9): a restrained warn banner with an optional
 * machine-readable detail line (e.g. receiver 202 partial / 409 counts) and a
 * retry. Presentational; the page maps transport / receiver failures into these.
 */
interface ErrorPanelProps {
  message: string;
  /** Optional mono detail, e.g. "202 partial · 498/512 accepted · 14 failed". */
  detail?: string;
  onRetry: () => void;
}

export const ErrorPanel: React.FC<ErrorPanelProps> = ({ message, detail, onRetry }) => (
  <div data-testid="upload-error">
    <div className="flex items-start gap-3 rounded border border-warn/30 bg-warn-tint px-4 py-3.5">
      <span className="mt-px flex-none text-warn">
        <FaExclamationTriangle className="h-[18px] w-[18px]" />
      </span>
      <div>
        <div className="text-[13px] font-semibold text-warn">{message}</div>
        <div className="mt-1 text-[12.5px] leading-relaxed text-fg-muted">
          Nothing was processed — fix the study and try again.
        </div>
        {detail && (
          <div className="mt-2.5 rounded-[2px] border border-warn/20 bg-warn/5 px-2.5 py-2 font-mono text-[11px] text-warn">
            {detail}
          </div>
        )}
      </div>
    </div>
    <div className="mt-5 flex justify-end">
      <Button variant="secondary" onClick={onRetry}>
        <FaRedo className="h-3.5 w-3.5" />
        Try again
      </Button>
    </div>
  </div>
);
